import { useTranslation } from 'react-i18next';
import Pill from '../Pill/Pill';
import {
  CustomerStatus,
  customerStatusToPillColor,
  customerStatusToTranslationKey,
} from '../../shared/customerStatusToTranslationKey';

type CustomerStatusPillProps = {
  status: CustomerStatus;
};

const CustomerStatusPill = ({ status }: CustomerStatusPillProps) => {
  const { t } = useTranslation();

  return (
    <Pill
      text={t(customerStatusToTranslationKey(status))}
      color={customerStatusToPillColor(status)}
    />
  );
};

export default CustomerStatusPill;
